(ns client-portal.client.smart-ordering.filters.views
  (:require [client-portal.client.day-part-schedules.data :as day-part-schedules.d]
            [client-portal.client.smart-ordering.filters.data :as so.filters.d]
            [client-portal.client.smart-ordering.tags.data]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.sessions.data :as vi.sessions.d]
            [client-portal.client.voice-insights.tags.data :as tags.d]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.components :as c]
            [shared.core.constants :as constants]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]
            [clojure.string :as s]))

(def duration-options
  (concat
    (mapv (fn [[start end]]
            {:name (str start "-" end " seconds")
             :value {:unit "second" :start start :end end}})
          [[0 30] [30 60] [60 90] [90 120]])
    (mapv (fn [[start end]]
            {:name (str start (if end (str "-" end) "+") " minutes")
             :value {:unit "minute" :start start :end end}})
          [[2 3] [3 nil]])))

(defn filter-pair-child [{:keys [config parent-index index children-by-name]}]
  (let [child (-> @(re/subscribe [:so-filters/filter-data- config])
                  (get parent-index)
                  :children
                  (get index))
        child-by (:by child)]
    [:div {:style {:display :flex
                   :align-items :center
                   :gap 8}}
     [:div {:style {:display :flex
                    :align-items :center
                    :gap 6
                    :flex 1}}
      [:div {:style {:width 170}}
       [alc/up-dropdown {:placeholder "Child Tag"
                         :value child-by
                         :on-change (fn [v]
                                      (re/dispatch [:so-filters/update-filter-pair-child config parent-index index :by v])
                                      (re/dispatch [:so-filters/update-filter-pair-child config parent-index index :condition
                                                    (or (:condition child) "include")])
                                      (re/dispatch [:so-filters/update-filter-pair-child config parent-index index :join
                                                    (or (:join child) "or")])
                                      (re/dispatch [:so-filters/update-filter-pair-child config parent-index index :value nil]))
                         :options (mapv (fn [[child-name _]]
                                          {:value child-name
                                           :text (tag/tag->display-name {:name child-name})})
                                        (sort children-by-name))}]]
      [:div {:style {:width 110}}
       [alc/up-dropdown {:placeholder "Condition"
                         :value (:condition child)
                         :on-change #(re/dispatch [:so-filters/update-filter-pair-child config parent-index index :condition %])
                         :options [{:value "include" :text "Includes"}
                                   {:value "exclude" :text "Excludes"}]}]]
      [:div {:style {:width 100}}
       [alc/up-dropdown {:placeholder "Any Of"
                         :value (:join child)
                         :on-change #(re/dispatch [:so-filters/update-filter-pair-child config parent-index index :join %])
                         :options [{:value "or" :text "Any Of"}]}]]
      [:div {:style {:flex 1}}
       [alc/up-multiple-dropdown
        {:placeholder (str "Select " (or (some->> child-by (hash-map :name) (tag/tag->display-name))
                                         "Value"))
         :form-path (conj (so.filters.d/filter-data-path config) parent-index :children index)
         :form-name :value
         :options (->> (get children-by-name child-by)
                       (mapv (fn [opt]
                               {:text (tag/tag->display-name {:value (:value opt)})
                                :value (:value opt)}))
                       (distinct)
                       (sort-by :text))}]]]
     [alc/up-ghost-button {:icon-type :CrossIcon
                           :on-click #(re/dispatch [:so-filters/remove-filter-pair-child config parent-index index])}]]))

(defn filter-pair [{:keys [config index]}]
  (let [filter-pair (get @(re/subscribe [:so-filters/filter-data- config]) index)
        filter-by (:by filter-pair)
        tags-data @(re/subscribe [:so-tags/list-by-current-concept-id-])
        tags (tags.d/all-tags (util/when-not-loading tags-data))
        concept-day-parts (some->> (util/when-not-loading @(re/subscribe [:day-parts/by-current-concept-id-]))
                                   (day-part-schedules.d/concept-day-parts))
        filter-by-options (filterv identity
                                   [{:value "tags" :text "Tags"}
                                    {:value "day-of-week" :text "Day of Week"}
                                    {:value "time-of-day" :text "Time of Day"}
                                    (when (not-empty concept-day-parts)
                                      {:value "day-part" :text "Day Part"})
                                    {:value "duration" :text "Duration"}])
        filter-by-tags? (= filter-by "tags")
        any-only? (contains? #{"day-of-week" "time-of-day" "day-part" "duration"} filter-by)
        selected-tag-names (when filter-by-tags?
                             (some->> (:value filter-pair)
                                      (map #(:name (util/->kebab-case-keywords %)))
                                      (into #{})))
        children-by-name (when (not-empty selected-tag-names)
                           (some->> tags
                                    (filter #(contains? selected-tag-names (:name %)))
                                    (mapcat #(tags.d/tag-children->options nil (:children %)))
                                    (distinct)
                                    (not-empty)
                                    (group-by :name)))
        selected-children (when children-by-name
                            (or (not-empty (:children filter-pair))
                                [vi.sessions.d/default-filter-pair-child]))]
    [alc/card {:title (str "Filter " (inc index))
               :title-inline-contents [[c/spacer]
                                       [alc/up-button {:icon-type :DeleteIcon
                                                       :on-click #(re/dispatch [:so-filters/delete-filter-pair config index])}]
                                       (when selected-children
                                         [alc/up-button {:icon-type :AddIcon
                                                         :on-click #(re/dispatch [:so-filters/add-filter-pair-child config index])}
                                          "Add Child Tag"])]
               :style {:gap 8
                       :padding "8px 16px 16px"}}
     [:div {:style {:display :flex
                    :align-items :center
                    :gap 6}}
      [:div {:style {:width 190}}
       [alc/up-dropdown {:placeholder "Filter by"
                         :value filter-by
                         :on-change (fn [v]
                                      (re/dispatch [:so-filters/update-filter-pair config index :by v])
                                      (re/dispatch [:so-filters/update-filter-pair config index :value nil])
                                      (re/dispatch [:so-filters/update-filter-pair config index :children []]))
                         :options filter-by-options}]]
      [:div {:style {:width 110}}
       [alc/up-dropdown {:placeholder "Condition"
                         :value (:condition filter-pair)
                         :on-change #(re/dispatch [:so-filters/update-filter-pair config index :condition %])
                         :options [{:value "include" :text "Includes"}
                                   {:value "exclude" :text "Excludes"}]}]]
      [:div {:style {:width 100}}
       [alc/up-dropdown {:placeholder (if any-only? "Any Of" "Any / All")
                         :value (:join filter-pair)
                         :on-change #(re/dispatch [:so-filters/update-filter-pair config index :join %])
                         :options (filterv identity
                                           [{:value "or" :text "Any Of"}
                                            (when-not any-only?
                                              {:value "and" :text "All Of"})])}]]
      [:div {:style {:flex 1}}
       (when filter-by
         [alc/up-multiple-dropdown
          {:placeholder (str "Select " (or (some->> filter-by-options
                                                    (filter #(= (:value %) filter-by))
                                                    (first)
                                                    :text)
                                           "Value"))
           :form-path (conj (so.filters.d/filter-data-path config) index)
           :form-name :value
           :options (mapv (fn [option]
                            {:value (util/->kebab-case-string option)
                             :text (if filter-by-tags?
                                     (tag/tag->display-name option)
                                     (:name option))})
                          (case filter-by
                            "tags" (->> (tags.d/tags->name-value-pairs tags)
                                        (sort-by tag/tag->display-name))
                            "day-of-week" (mapv #(hash-map :name % :value %) constants/days-of-the-week)
                            "time-of-day" (mapv #(hash-map :name %
                                                           :value (util/time-of-day-with-leading-zero %))
                                                constants/hours-of-day)
                            "day-part" (mapv #(hash-map :name (util/->capitalize-words (:label %))
                                                        :value (:label %))
                                             concept-day-parts)
                            "duration" duration-options
                            []))}])]]
     (when selected-children
       (into [:div {:style {:display :flex
                            :flex-direction :column
                            :gap 8}}]
             (map-indexed (fn [child-idx _]
                            [filter-pair-child {:config config
                                                :parent-index index
                                                :index child-idx
                                                :children-by-name children-by-name}])
                          selected-children)))]))

(defn filter-popover [{:keys [config]}]
  (let [filter-data @(re/subscribe [:so-filters/filter-data- config])]
    [:div {:style {:background-color (style/alc-color "Background/up_level")
                   :border (str "1px solid " (style/alc-color "Border/divider_secondary"))
                   :border-radius 6
                   :box-shadow (style/alc-shadow "shadow/common_overlay")
                   :z-index 49
                   :padding 12
                   :display :flex
                   :flex-direction :column
                   :gap 12
                   :width 650}}
     [:div {:style {:display :flex
                    :align-items :center
                    :justify-content :space-between}}
      [:span {:style {:font-size 20
                      :font-weight 400
                      :line-height 1.4
                      :color (style/alc-color "Text/primary_header")}}
       "Filter"]
      [alc/up-button {:icon-type :AddIcon
                      :on-click #(re/dispatch [:so-filters/add-filter-pair config])}
       "Add New"]]
     (into [:div {:style {:display :flex
                          :flex-direction :column
                          :gap 8}}]
           (map-indexed (fn [idx _]
                          [filter-pair {:config config
                                        :index idx}])
                        filter-data))
     [:div {:style {:display :flex
                    :align-items :center
                    :gap 10}}
      [alc/up-button {:disabled (empty? (filter :value filter-data))
                      :on-click #(re/dispatch [:so-filters/clear config])}
       "Reset Filters"]
      [c/spacer]
      [alc/up-call-to-action-button {:on-click #(re/dispatch [:so-filters/apply config])}
       "Apply"]]]))

(defn applied-filter-pills [{:keys [config]}]
  (let [applied (filterv :value @(re/subscribe [:so-filters/applied-filters-]))
        join-text #(if (= % "and") "All Of" "Any Of")
        condition-text #(-> % (util/pluralize 2) (util/->capitalize-words))
        quoted #(str "\"" (s/join ", " %) "\"")]
    (when (not-empty applied)
      (into [:div {:style {:display :flex
                           :align-items :center
                           :flex-wrap :wrap
                           :gap 8}}]
            (concat
              (map-indexed
                (fn [idx {:keys [by condition join value children]}]
                  (let [value-label (->> value
                                         (map #(if (= by "tags")
                                                 (tag/tag->display-name (util/->kebab-case-keywords %))
                                                 (get % "name")))
                                         (quoted))
                        children-label (some->> (not-empty children)
                                                (map (fn [child]
                                                       (str "\"" (tag/tag->display-name {:name (:by child)}) "\" "
                                                            (condition-text (:condition child)) " "
                                                            (join-text (:join child)) " "
                                                            (->> (:value child)
                                                                 (map #(tag/tag->display-name {:value %}))
                                                                 (quoted)))))
                                                (s/join " and "))]
                    [alc/up-tag {:text (str (util/->capitalize-words by) " "
                                            (condition-text condition) " "
                                            (when join (str (join-text join) " "))
                                            value-label
                                            (when (and (= by "tags") children-label)
                                              (str " and " children-label)))
                                 :selected true
                                 :on-close #(re/dispatch [:so-filters/remove-applied-filter config idx])}]))
                applied)
              [[alc/up-ghost-button {:on-click #(re/dispatch [:so-filters/clear config])}
                "Clear Filters"]])))))

(defn filter-button [{:keys [config]}]
  (let [applied- (re/subscribe [:so-filters/applied-filters-])
        open?- (re/subscribe [:so-filters/popover-open?- config])
        tags- (re/subscribe [:so-tags/list-by-current-concept-id-])]
    (fn [{:keys [config]}]
      (let [filter-count (count (filter :value @applied-))
            open? @open?-]
        [alc/up-popover
         {:open open?
          :on-open-change #(re/dispatch [:so-filters/toggle-popover config %])
          :modal false
          :side :bottom
          :align :end
          :side-offset 8
          :class-name "w-auto p-0 border-0 bg-transparent shadow-none"
          :trigger [:span {:style {:display :inline-flex}}
                    [alc/up-button (cond-> {:icon-type :FilterIcon
                                            :disabled (util/loading? @tags-)}
                                     open? (assoc :variant "togglePressed"))
                     (if (pos? filter-count)
                       (str filter-count " " (util/pluralize "Filter" filter-count))
                       "Add Filter")]]
          :content [filter-popover {:config config}]}]))))
